export default "__VITE_ASSET__b292b1d3__"